import { render } from "./InvitedUsersTable.vue?vue&type=template&id=565a0768"
import script from "./InvitedUsersTable.vue?vue&type=script&lang=js"
export * from "./InvitedUsersTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dharmik/www/pfizer-invoicing-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__